import { render, staticRenderFns } from "./ResellerApiKeys.vue?vue&type=template&id=059f6367"
import script from "./ResellerApiKeys.vue?vue&type=script&lang=js"
export * from "./ResellerApiKeys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports